import { NextSeo } from 'next-seo';
import { useIntl } from 'react-intl';

import { Banner } from '@/core/components/Layout/Banner';
import {
  Subheader,
  Title,
  TitleWrapper,
  Wrapper,
} from '@/core/components/PageLayout';
import { MarginWrapper } from '@/core/components/MarginWrapper';
import { Breadcrumbs } from '@/core/components/Breadcrumbs';
import { navigationMessages } from '@/core/messages/navigation.messages';
import { useLocalizedOGTitle } from '@/core/hooks/useLocalizedOGTitle';

import {
  MomentId,
  MomentsDataType,
} from '@/features/Moments/moments.types';

import {
  getBackendImage,
  getKeywordsProps,
} from '@/utils/helpers';
import { RequestResponse } from '@/utils/request.types';

import { Moments } from './MomentsGrid';

export const MomentsPage = ({
  momentsData,
  pageData,
}: {
  momentsData: RequestResponse<Array<MomentId>>;
  pageData: RequestResponse<MomentsDataType>;
}) => {
  const { formatMessage } = useIntl();

  const OGTitle = useLocalizedOGTitle(
    pageData.data.attributes.meta?.OGTitle ||
    pageData.data.attributes.meta?.title ||
    formatMessage(navigationMessages.moments)
  );

  return (
    <>
      <NextSeo
        title={pageData.data.attributes.meta?.title || formatMessage(navigationMessages.moments)}
        description={pageData.data.attributes.meta?.description || ''}
        openGraph={{
          description: pageData.data.attributes.meta?.OGDescription ||
            pageData.data.attributes.meta?.description || '',
          title: OGTitle,
        }}
        {...getKeywordsProps(pageData.data.attributes.meta?.keywords)}
      />
      <div>
        <Banner
          TitleText={pageData.data.attributes.banner.header}
          Image={getBackendImage(
            pageData.data.attributes.banner.banner.data?.attributes?.url
          )}
          SubtitleText={pageData.data.attributes.banner.paragraph}
        />
        <Breadcrumbs />
        <div>
          <Wrapper>
            <MarginWrapper>
              <Subheader>
                {pageData.data.attributes?.header?.title}
              </Subheader>
              <TitleWrapper>
                <Title>{pageData.data.attributes?.header?.subtitle}</Title>
              </TitleWrapper>
              <Moments
                data={momentsData.data}
                maxItems={momentsData?.meta?.pagination?.total || 30}
              />
            </MarginWrapper>
          </Wrapper>
        </div>
      </div>
    </>
  );
};
